import { Paper } from '@mui/material';
import { ChatMessage } from '../../interfaces/AiChat/ChatMessage';
import { sharedColors } from '../../utils/Style';

export const UserMessage = ({ message }: { message: ChatMessage }) => {
  return (
    <Paper
      sx={{
        width: 'fit-content',
        maxWidth: '70%',
        alignSelf: 'flex-end',
        padding: 1.5,
        borderRadius: '10px',
        backgroundColor: sharedColors.statusGreenLightest,
      }}
    >
      {message.text}
    </Paper>
  );
};
